import { useEffect, useState } from "react";
import { planApi } from "../../data/api/PlanApi";
import { Plan, SoulPlanModel } from "../../data/models/Plan/PlanModel";

export function usePlan() {
  const [plan, setPlan] = useState<SoulPlanModel | null>(null);
  const [plans, setPlans] = useState<Plan[] | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await planApi.getPlan.request(null);
        if (!res.isSuccess || !res.data) {
          setPlans([]);
          setPlan(null);
          return;
        }
        setPlans(Array.isArray(res.data.plans) ? res.data.plans : []);
        setPlan(res.data.soulPlan ?? null);
      } catch (e) {
        setPlans([]);
        setPlan(null);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return { plan, loading, plans };
}
